
<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="professional_header">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="professional_heading">
                        <h1>교정 전문 서비스  </h1>
                        <img src="../../../assets/images/proofreaional_poweredby_img.png" alt="poweredBy">
                    </div>
                    <div class="professional_contents">
                        <p>저널은 논리적인 주장, 학문적 가치, 강한 방법론등을 고려하여 논문 게재의 여부를 <br>결정합니다. 언어적 오류를 제거하는 것은 논문 출판에 있어 매우 중요한 부분인 만큼, <br />트링카는 원고에서 잘못된 언어가 제거되도록 도와줍니다. </p>
                        <p>이나고 교정 서비스는 언어 사용 및 문법을 넘어서 원고의 논리적 흐름, 구조, 저널<br /> 가이드라인에 따라 학술 주제 전문가가 교정 합니다. 또한,  원고 제출 전 피어<br /> 리뷰도 함께 제공됩니다. </p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="professional_img">
                        <img src="../../../assets/images/searching_for_proofreading.png" alt="Proofreading">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="profressional_pricing">
        <div class="profressional_pricing_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2><img src="../../../assets/images/Proofreading_icons.png" alt="icon"> 교정 </h2>
                            <p>저널에 제출하기 전  원고에 대한 문법 및 일관성 체크가 필요하는분들께 적합 원하는 작가에게 적합</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <ul>
                                <li>문법 및 구문론 수정</li>
                                <li>구두법 체크</li>
                                <li>맞춤법 및 시제 검사 </li>
                                <li>쓰기 스타일 및 일관성</li>
                                <li>에디터 매칭(1명 기준)</li>
                                <li>최대 1년간 무제한 Q&A</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 paddingSectionRemove">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2><img src="../../../assets/images/CopyEditing_Icon.png" style="width: 40px;" alt="editing"> 프리미엄 교정 </h2>
                            <p>문장 수준의 영어 교정, 문법 및 구문법 수정을 포함하여 언어적으로 완벽에 가까운 원고가 필요한 분들께 적합</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <div class="additional_services">
                                <p><img src="../../../assets/images/Proofreading_icons.png" alt="icon" style="width: 20px;"> 교정의 모든 것</p>
                                <span><i class="fa fa-plus"></i></span>
                            </div>
                            <ul>
                                <li>글의 명확성과 가독성 향상</li>
                                <li>어드밴스 문법 검사</li>
                                <li>단어 및 관용어 선택</li>
                                <li>문장 구조</li>
                                <li>기초적인 포맷팅</li>
                                <li>단어 수 10% 감소</li>
                                <li>주제 영역에 따라 2명의 원어민 매칭 </li>
                                <li>1 페이지 분량의 원고 평가 보고서 
                                    <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section CopyEditingSection">
                                        <p>원고 평가보고서는 원고 관련 비평하는 내용을 포함한 모든 코멘트가 상세 보고서를 통해 확인 가능 합니다.</p>
                                    </div>
                                </li>
                                <li>120일 동안 무제한 교정* 
                                    <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section oneDayTooltip">
                                        <p>새로운 저널 또는 동일 저널에 따라 재 포맷팅 및 무제한 재 교정을 합니다. </p>
                                        <img src="../../../assets/images/PaperIcons.png" alt="icon">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2> <img src="../../../assets/images/SubstantiveEditing_Icon.png"  style="width: 40px;" alt="editing"> 수퍼프리미엄 교정</h2>
                            <p>문장 수준의 영어 교정 외 논리적 흐름, 구조 및 내용 구성까지 개선이 필요한 분들께 적합 </p>
                        </div>
                        <div class="prof_card_bodysection">
                            <div class="additional_services">
                                <p><img src="../../../assets/images/CopyEditing_Icon.png" style="width: 30px;" alt="icon"> 복사 편집의 모든 것</p>
                                <span><i class="fa fa-plus"></i></span>
                            </div>
                            <ul>
                                <li>글 수준 향상</li>
                                <li>기술 정확도</li>
                                <li>논리적 흐름</li>
                                <li>원고 구조</li>
                                <li>어드밴스 포맷팅 및 프레젠테이션</li>
                                <li>단어 수 20% 감소</li>
                                <li>커버레터 </li>
                                <li><strong>4 페이지</strong> 분량의 어드밴스 원고 평가<br /> 보고서 <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section SubstantiveSection">
                                        <p>원고 평가보고서는 원고 관련 비평하는 내용을 포함한 모든 코멘트가 상세 보고서를 통해 확인 가능 합니다.</p>
                                    </div>                                
                                </li>
                                <li>무제한 교정(1년 간)  <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section secondLastTooltip">
                                        <p>새로운 저널 또는 동일 저널에 따라 재 포맷팅 및 무제한 재 교정을 합니다. </p>
                                        <img src="../../../assets/images/PaperIcons.png" alt="icon">
                                    </div>
                                </li>
                                <li>
                                    리젝쉴드(1년 간)* <span class="prof_tooltipSection"><img src="../../../assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section lastTooltipSection">
                                        <p> 거절된 원고로 다시 제출할 경우 모든게 준비 되었는지 미리 확인합니다.</p>
                                        <img src="../../../assets/images/Rejections_Shield.png" alt="shield" style="margin-left: -20px;">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="paidSection">
                        <p>*이 서비스는 추가 비용이 발생됩니다. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>